export default {
    AST: 'AST',
    CUST: 'Cust',
    PUBLIC: 'Public'
};
